import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import {
    withStyles, Typography,
} from '@material-ui/core';


import Calendar from '../../pages/Calendar/Calendar';

const styles = theme => ({
    root: {
        background: theme.palette.grey[100],
        padding: theme.spacing(2),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2, 4),
        },
    },
    topContainer: {
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 500,
    },
    description: {
        marginBottom: theme.spacing(1),
    },
    content: {
        [theme.breakpoints.down('xs')]: {
            background: theme.palette.grey[100],
        },
    },
});

class CalendarBox extends React.Component {
    render() {
        const {
            classes, translate, className,
        } = this.props;

        return (
            <div className={classnames(classes.root, className)}>
                <div className={classes.topContainer}>
                    <Typography variant="h6" className={classes.title}>
                        {translate('dashboard.calendar')}
                    </Typography>
                    <Typography className={classes.description}>
                        {translate('dashboard.calendarDescription')}
                    </Typography>
                </div>
                <div className={classes.content}>

                    <Calendar />
                </div>
            </div>
        );
    }
}

CalendarBox.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    className: PropTypes.string,
};

CalendarBox.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(CalendarBox));
